import { render, staticRenderFns } from "./TipBar.vue?vue&type=template&id=1caf79f2&scoped=true"
import script from "./TipBar.vue?vue&type=script&lang=js"
export * from "./TipBar.vue?vue&type=script&lang=js"
import style0 from "./TipBar.vue?vue&type=style&index=0&id=1caf79f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caf79f2",
  null
  
)

export default component.exports